import {Injectable, OnDestroy} from "@angular/core";
import {
  CanActivate,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from "@angular/router";
import {Subscription} from "rxjs";

import {AuthenticationService} from "../_services/authentication.service";
import {GuestService} from "../_services/guest.service";

@Injectable({providedIn: "root"})
export class CustomGuard implements CanActivate, OnDestroy {
  private subscriptions = new Subscription();

  constructor(
    private authenticationService: AuthenticationService,
    private guestService: GuestService,
    private router: Router
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const token = this.authenticationService.getToken();

    // verificam daca incercam sa facem o autentificare pe guest
    const guestToken = this.guestService.getToken();
    if (state.url.includes("signinguest")) {
      // daca exista guestJWT atunci se va deschide modulul de guest
      if (guestToken) {
        this.router.navigate(["/guest"]);
      }
    }

    // daca se acceseaza login sau signup si suntem autentificati, atunci redirect la dashboard
    if (token && (state.url.includes("signin") || state.url.includes("signup")) && !state.url.includes("signinguest")) {
      this.router.navigate(["/portal/dashboard/main"]);
    }

    return true;
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
